// English texts. Must mirror the structure of it.js (missing keys fall back to Italian).
import legal from "./legal/en";
import home from "./home/en";

const en = {
  meta: {
    description:
      "Qapex: Digital transformation, automation, innovation. We build custom software solutions to help your business grow.",
  },


  contactForm: {
    options: {
      "QA Service Provider": "QA Service Provider",
      "QA Consulting": "QA Consulting",
      "QUACK": "QUACK",
      "SubQ": "SubQ",
      "Sviluppo Custom": "Custom software development",
    },
    sending: "Sending...",
    submit: "SEND",
    success: "Message sent! We'll get back to you as soon as possible.",
    error: "Something went wrong. Please try again.",
    privacy: "I declare that I have read the <link>Privacy Policy</link> and consent to the processing of my data to handle this request.",
  },

  workWithUs: {
    eyebrow: "Work with us",
    heroTitle: "Join",
    heroHighlight: "our team.",
    heroText: "Shape the future of quality and digital innovation with us.",
    openPositions: "Open positions",
    apply: "Apply",
    applyNow: "Apply now",
    positions: [
      {
        id: "Software Tester",
        title: "Software Tester",
        description:
          "We're looking for a detail-oriented Software Tester. You'll be responsible for executing test cases, tracking bugs and ensuring the highest quality of our software products. Experience with manual testing is required; automation is a plus.",
      },
      {
        id: "QA Engineer",
        title: "QA Engineer",
        description:
          "Join us as a QA Engineer to design and implement testing strategies. You should be proficient with automated testing tools and CI/CD pipelines, and have a strong understanding of the software development life cycle.",
      },
      {
        id: "Full Stack Developer",
        title: "Full Stack Developer",
        description:
          "We're looking for a Full Stack Developer to build scalable web applications. Proficiency in React, Node.js and modern database technologies is essential. You'll work closely with our design and QA teams to deliver outstanding user experiences.",
      },
      {
        id: "Partner Commerciale",
        title: "Sales Partner",
        description:
          "QAPEX SRL is looking for a Sales Agent – Qualified leads provided\nWe're looking for an independent sales agent to develop new B2B opportunities.\nWhat makes it different from a typical sales role? We provide the leads.\nWe give you a list of pre-selected, qualified companies, so you can focus your time on selling: outreach, relationship building, negotiation and closing.",
      },
    ],
  },

  applyModal: {
    title: "Apply Now",
    close: "Close",
    fullName: "Full Name",
    namePlaceholder: "John Smith",
    position: "Position",
    selectPosition: "Select a position",
    email: "Email Address",
    emailPlaceholder: "john@example.com",
    uploadCv: "Upload Resume",
    uploadCvHint: "Click to upload your CV",
    privacy: "I accept the <link>Privacy Policy</link> and consent to the processing of my personal data.",
    submitting: "SENDING...",
    submit: "SUBMIT APPLICATION",
    autoresponse: "We've received your application and will get back to you shortly.",
    fileTooLarge: "The file is too large. Maximum size: 5MB.",
    fileTypeInvalid: "Unsupported file type. Please upload a PDF or Word document.",
    cvRequired: "Please upload your resume.",
    privacyRequired: "Please accept the privacy policy.",
  },

  legal,
  home,
};

export default en;
